import { memo, FC, ChangeEvent, useRef, useEffect } from 'react'
import {
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  IconButton,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react'

import { useDebounce } from 'hooks'
import getAssets from 'utils/assets/getAssets'
import { Question } from 'components/icons'

type Props = {
  placeholder?: string
  name?: string
  filter: any
  setFilter: any
  filteredFields?: string[]
}

const SearchInput: FC<Props> = ({ name = 'search', filter, setFilter, placeholder, filteredFields }) => {
  const ref = useRef<HTMLInputElement | null>(null)

  const Search = getAssets('Icon', 'Search')

  function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value
    setFilter({ ...filter, [name]: value })
  }

  const debouncedGandleOnChange = useDebounce({ callback: handleOnChange })

  useEffect(() => {
    if (ref.current) ref.current.value = filter[name]
  }, [filter])

  return (
    <Flex gap={1} alignItems="center">
      {filteredFields && filteredFields.length > 0 && (
        <Popover>
          <PopoverTrigger>
            <IconButton aria-label="" icon={<Question />} variant="ghost" />
          </PopoverTrigger>

          <PopoverContent color="light" bg="primary" borderColor="primary">
            <PopoverArrow bg="primary" />
            <PopoverHeader pt={4} fontWeight="bold" border="0">
              Campos filtrados:
            </PopoverHeader>
            <PopoverCloseButton />
            <PopoverBody>
              <UnorderedList fontSize="sm">
                {filteredFields.sort().map((element) => (
                  <ListItem key={element}>{element}</ListItem>
                ))}
              </UnorderedList>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}

      <InputGroup minWidth="250px" onChange={debouncedGandleOnChange}>
        <InputLeftElement>
          <Search color="primary" />
        </InputLeftElement>
        <Input
          id="search"
          name="search"
          bg="light"
          _placeholder={{ color: useColorModeValue('gray.400', 'gray.600') }}
          ref={ref}
          placeholder={placeholder}
        />
      </InputGroup>
    </Flex>
  )
}

export default memo(SearchInput)
